import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const userService = {
  // Get all users
  getAllUsers: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.USERS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get user by ID
  getUserById: async (userId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.USER_BY_ID(userId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new user
  createUser: async (userData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}${API_URLS.REGISTER}`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update user
  updateUser: async (userId, userData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.USER_BY_ID(userId)}`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete user
  deleteUser: async (userId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}${API_URLS.USER_BY_ID(userId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update user status
  updateUserStatus: async (userId, status) => {
    try {
      const response = await axios.patch(`${API_BASE_URL}${API_URLS.USER_STATUS(userId)}`, {
        status: status
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all permissions
  getAllPermissions: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.PERMISSIONS}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get all roles
  getAllRoles: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.ROLES}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default userService;